import React, { useState } from "react";
import FormLogin from "./components/FormLogin";
import FormForgotPassword from "./components/FormForgotPassword";
import AuthContext from "../../contexts/AuthContext";

import "./assets/style.css";
import { useLocation } from "react-router-dom";
import { useContext } from "react";

const Login: React.FC = () => {
  const isDev = process.env.REACT_APP_ALLOW_LOCAL_LOGIN === 'true' ||
                (process.env.REACT_APP_ALLOW_LOCAL_LOGIN !== 'false' && window.location.hostname === 'localhost');
  const [isLogin] = useState(true);
  const query = useQuery();
  const { LoginSaml, } = useContext(AuthContext);
  
  function useQuery(): URLSearchParams {
    return new URLSearchParams(useLocation().search);
  }

  function ssoMessage(){
    var sso = query.get("sso");
    if (sso === "0") {  
      return <p className="signIn__text">Your user is not allowed to access this application, please contact the support team.</p>
    } 
    else if (sso === "1") {  
      LoginSaml();
    }
    return null;
  }

  return (
    <div className="wrapper-login">
      <div className="row row--vCenter">
        <div className="col--2 signIn fullHeight">
        
          <div className="signIn__container">
            <div className="form__logo">
            </div>
            {ssoMessage()}

            <h1 className="signIn__title">Login</h1>
            {/* <p className="signIn__text">
              {isLogin
                ? "Please enter your credentials to proceed."
                : "Reset, reactivate or set your password"}
            </p> */}
            {(!isDev || isLogin) ? <FormLogin /> : <FormForgotPassword />}
          </div>
        </div>


      </div>
    </div>
  );
};

export default Login;
